// @ is an alias to /src
import { Carousel, Slide } from "vue-carousel";
import { Donuz } from "donuz-js/Donuz";
import VuejsPaginate from "vuejs-paginate";
import FaixaApp from "@/components/FaixaApp.vue";
import Loading from "@/components/Loading.vue";

export default {
    name: "home",
    components: {
        Carousel,
        Slide,
        VuejsPaginate: "paginate",
        FaixaApp,
        Loading
    },
    data() {
        return {
            obj: {},
            response: {},
            prizes: [],
            categories: [],
            categoriaAtual: {},
            propagandas: [],
            banners: [],
            mudarCateg: false,
            pagination: 0,
            prizesLoading: true,
            hide: false,
            adminLoad: true,
            client: false,
            forgotPassword: null,
            email: '',
            cpf: '',
            password: '',
        };
    },
    updated() {
        M.Modal.init(document.querySelectorAll('.modal'), { opacity: 0.5 });
        M.Carousel.init(document.querySelectorAll('.carousel'), { shift: 140, padding: 0, numVisible: 3 });
    },
    async beforeMounted() {

    },
    async created() {
        this.obj = await this.getAdmins();
        this.obj = this.obj.estabelecimentos[0];

        this.obj.banners.forEach(element => {
            if (element.descricao.includes('propaganda')) {
                this.propagandas.push(element);
            } else {
                this.banners.push(element);
            }
        });

        this.adminLoad = false

        this.response = await Donuz.category.getCategories();

            this.response = await Donuz.prizes.getRewardByTag(
                'destaque', this.obj.ordem_exibicao
            );

            if (this.response.status == 200) {
                this.prizes = this.response.premios;
                this.prizesLoading = false;
            }
            if (this.response.status == 410) {
                this.prizesLoading = false;
            }

        if (sessionStorage.getItem(btoa("cliente")) != null) {
            this.client = JSON.parse(atob(sessionStorage.getItem(btoa("cliente"))));
        }

    },
    methods: {
        paginate: async function (page) {
            this.prizesLoading = true;
            let per_page = this.obj.premios_por_pagina;
            let max = per_page;

            if (Object.keys(this.categoriaAtual).length == 0) {
                let response = await Donuz.prizes.getRewards(
                    null,
                    ((page - 1) * per_page) + "," + max
                );
                if (response.status == 200) {
                    this.prizes = response.premios;
                    this.prizesLoading = false;
                }
            } else {
                this.prizesLoading = true;
                this.response = await Donuz.prizes.getRewardByCategory(this.categoriaAtual.id, this.categoriaAtual.subcateg, null, null, this.obj.premios_por_pagina);
                if (this.response.status == 200) {
                    this.prizes = this.response.premios;

                } else {
                    this.prizes = [];
                }
                this.pagination = parseInt(this.response.registros / this.obj.premios_por_pagina);
                if (this.response.registros % this.obj.premios_por_pagina != 0) {
                    this.pagination++;
                }
                this.prizesLoading = false;
            }


        },
        getPrizesByCateg: async function (id, subcateg = null, mudarCate = false) {
            this.categoriaAtual.id = id;
            this.categoriaAtual.subcateg = subcateg;

            if (mudarCate) {
                this.mudarCateg = true
            }

            this.prizesLoading = true;
            this.response = await Donuz.prizes.getRewardByCategory(id, subcateg, null, null, this.obj.premios_por_pagina);
            if (this.response.status == 200) {
                this.prizes = this.response.premios;

            } else {
                this.prizes = [];
            }
            this.pagination = parseInt(this.response.registros / this.obj.premios_por_pagina);
            if (this.response.registros % this.obj.premios_por_pagina != 0) {
                this.pagination++;
            }
            this.prizesLoading = false;
            this.mudarCateg = false;
        },
        change: function (id) {
            let element = document.getElementsByClassName('btn-resgate')[id]
            if (element.classList.contains('hide')) {
                element.classList.remove('hide')
            } else {
                element.classList.add('hide')
            }
        },
        submit: async function (e) {
            e.preventDefault();
            let result = await Donuz.customer.signIn(this.cpf, this.password);
            if (result.status == 200) {
                M.toast({ html: result.mensagem, classes: "green" });
                let client = result.clientes[0];
                let saldo = await Donuz.balance.getCustomerBalance(result.token);
                client.saldo = parseFloat(saldo.saldo)
                    .toFixed(2)
                    .replace(".", ",");
                sessionStorage.setItem(btoa("cliente"), btoa(JSON.stringify(client)));
                sessionStorage.setItem(btoa("tokenCliente"), result.token);
                location.href = this.baseUrl;
            } else {
                M.toast({ html: result.mensagem, classes: "red" });
            }
        },
        forgot: async function (e) {
            e.preventDefault();
            let result = await Donuz.customer.forgotPassword(this.email)
            if (result.status == 200) {
                M.toast({ html: result.mensagem, classes: "green" });
            } else {
                M.toast({ html: result.mensagem, classes: "red" });
            }
        },
        open: function () {
            var elem = document.getElementById('modal1')
            var instance = M.Modal.getInstance(elem);
            instance.open();
        },
        moveCarousel(next) {
            var instance = M.Carousel.getInstance(document.getElementById('carousel-premios'));
            instance.prev();
            if (next) {
            } else {
                instance.next();
            }
        }
    },
    mounted() {
        document.addEventListener('DOMContentLoaded', function () {
            var elems = document.querySelectorAll('.collapsible');
            var instances = M.Collapsible.init(elems, {});
        });
    },


};